import { Typography } from 'src/components/common/Typography'
import React from 'react'
import {
  Noto_body1_b16,
  Noto_body1_m16,
  Noto_body2_m14,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import {
  Roboto_num1_b18,
  Roboto_num1_b24,
  Roboto_num1_r18,
  Roboto_num3_r14,
} from 'src/styles/fonts/RobotoFonts'
import { Container } from 'src/components/common/Container'
import { SmallDivider } from 'src/components/common/Divider'
import styled from 'styled-components'
import { ellip } from 'src/styles/mixin'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
import { getBrandAndCouponName, maskPhoneNumber } from 'src/utils'
import { CouponPurchaseProps } from 'src/pages/CouponPurchasePage'
import RenderIf from 'src/components/common/RenderIf'

const PurchaseCouponInfo = ({
  couponDetailData,
}: Pick<CouponPurchaseProps, 'couponDetailData' | 'handleServiceTermsModal'>) => {
  const { c_tel } = useCustomCookies()
  const maskPNumber = maskPhoneNumber(c_tel)

  return (
    <RenderIf when={!!couponDetailData}>
      <S.PurchaseCouponInfo.Container $option="flex_column">
        {/*주문자 정보 및 금액*/}
        <S.PurchaseCouponInfo.ConsumerInfo>
          주문자 {'\u00A0'} {maskPNumber}
        </S.PurchaseCouponInfo.ConsumerInfo>
        <S.PurchaseCouponInfo.PriceNotice $option="flex_row" $column_gap="4px">
          <Typography $fontStyle={Roboto_num1_b24}>
            {couponDetailData?.SalePrice?.toLocaleString()}
          </Typography>
          <Typography $fontStyle={Noto_subheading_b18}>원을 결제합니다.</Typography>
        </S.PurchaseCouponInfo.PriceNotice>
        {/*구매 대상 쿠폰 정보*/}
        <S.PurchaseCouponInfo.PurchaseCouponInfo $option="flex_column">
          <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
            {getBrandAndCouponName(couponDetailData?.CouponName || '').brandName}
          </Typography>
          <S.PurchaseCouponInfo.CouponName>
            {getBrandAndCouponName(couponDetailData?.CouponName || '').couponName}
          </S.PurchaseCouponInfo.CouponName>
          <Typography $fontStyle={Roboto_num3_r14} $color={'var(--black-50)'}>
            유효기간 {couponDetailData?.ValidDay}일
          </Typography>
        </S.PurchaseCouponInfo.PurchaseCouponInfo>
        {/*쿠폰 금액 및 할인율 표시*/}
        <S.PurchaseCouponInfo.CouponPriceInfo $option="flex_column" $row_gap="10px">
          <Container $option="flex_row_space_between">
            <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
              정가
            </Typography>
            <Typography $fontStyle={Roboto_num1_r18} $color="var(--black-50)">
              {couponDetailData?.RegularPrice?.toLocaleString()}
            </Typography>
          </Container>
          <Container $option="flex_row_space_between">
            <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
              할인율
            </Typography>
            <Typography $fontStyle={Roboto_num1_b18} $color="var(--brand-50)">
              {couponDetailData?.DiscountRate}%
            </Typography>
          </Container>
          <SmallDivider />
          <Container $option="flex_column" $row_gap="14px">
            <Container $option="flex_row_space_between">
              <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
                결제금액
              </Typography>
              <Typography $fontStyle={Roboto_num1_b18} $color="var(--black-90)">
                {couponDetailData?.SalePrice?.toLocaleString()}
              </Typography>
            </Container>
          </Container>
        </S.PurchaseCouponInfo.CouponPriceInfo>
      </S.PurchaseCouponInfo.Container>
    </RenderIf>
  )
}
export default PurchaseCouponInfo

const S = {
  PurchaseCouponInfo: {
    Container: styled(Container)`
      padding: 0 20px;
      background-color: var(--white);
    `,
    ConsumerInfo: styled(Typography)`
      ${Noto_body1_m16};
      padding: 0 10px;
      margin-top: 30px;
    `,
    PriceNotice: styled(Container)`
      align-items: center;
      padding: 0 10px;
      margin-top: 6px;
    `,
    PurchaseCouponInfo: styled(Container)`
      padding: 16px 18px;
      border-radius: 20px;
      background: var(--black-2);
      text-align: left;
      margin: 30px 0 14px 0;
    `,
    CouponName: styled(Typography)`
      ${ellip('line1')};
      margin: 2px 0 8px 0;
      ${Noto_body1_b16};
    `,
    CouponPriceInfo: styled(Container)`
      padding: 0 10px;
    `,
  },
}
